import { setCurrentUser } from './actionCreator';
import { currentUserReducer } from './reducers';

const currentUserReducers = {
  currentUser: currentUserReducer,
};

export { currentUserReducers, setCurrentUser };
